import { render } from "./ViewHero.vue?vue&type=template&id=0934bcc9&scoped=true"
import script from "./ViewHero.vue?vue&type=script&lang=js"
export * from "./ViewHero.vue?vue&type=script&lang=js"

import "./ViewHero.vue?vue&type=style&index=0&id=0934bcc9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0934bcc9"]])

export default __exports__